import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import cx from 'classnames';

import Icon from 'components/Icon';
import { TPost, TPostType } from 'lib/models/discussion';

import styles from './PostSummary.module.scss';

type PostSummaryProps = {
  post: TPost;
  className?: string;
  contentClassName?: string;
};

const PostSummary: React.FC<PostSummaryProps> = ({ post, className, contentClassName }) => {
  const [t] = useTranslation('discussions');
  const contentClasses = cx(styles.content, contentClassName);

  const summary = useMemo(() => {
    const { post_type, content } = post;

    switch (post_type) {
      case TPostType.MediaPost:
        return (
          <>
            <Icon iconName="icon_image" />
            {content ? (
              <p dangerouslySetInnerHTML={{ __html: content }} className={contentClasses} />
            ) : (
              <p className={contentClasses}>{t('discussions-in-messages.society-post-card.photos-count', { count: post.media.length })}</p>
            )}
          </>
        );
      case TPostType.DocumentPost:
        return (
          <>
            <Icon iconName="icon_document-2" />
            {content ? (
              <p dangerouslySetInnerHTML={{ __html: content }} className={contentClasses} />
            ) : (
              <p className={contentClasses}>{t('discussions-in-messages.society-post-card.docs-count', { count: post.documents.length })}</p>
            )}
          </>
        );
      case TPostType.PollPost:
        return (
          <>
            <Icon iconName="unordered_list" />
            <p dangerouslySetInnerHTML={{ __html: content }} className={contentClasses} />
          </>
        );
      case TPostType.TextPost:
      default:
        return <p dangerouslySetInnerHTML={{ __html: content }} className={contentClasses} />;
    }
  }, [post]);

  return <div className={cx(styles.container, className)}>{summary}</div>;
};

PostSummary.displayName = 'PostSummary';

export default PostSummary;
